import {
  fontSize,
  maxBreakpoints,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import * as copy from '../constants';

const { spacing, text, fonts } = theme;

export const card = css`
  height: 100%;
  position: relative;
`;

export const heading = css`
  margin: 0;
`;

export const link = css`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-decoration: none;
`;

export const imageWrapper = css`
  position: relative;
  margin: 0 auto ${pxToRem(spacing.md)} auto;
  border-radius: ${pxToRem(10)};
  overflow: hidden;
  padding-bottom: 75%;
  width: ${pxToRem(212)};
  height: ${pxToRem(204)};

  ${
    /*
    -webkit-mask-image fixes an issue Safari had with using border-radius with overflow: hidden
    on a container with an absolutely positioned element inside it.
    https://stackoverflow.com/questions/49066011/overflow-hidden-with-border-radius-not-working-on-safari
  */ ''
  }
  mask-image: radial-gradient(white, black);
  -webkit-mask-image: -webkit-radial-gradient(white, black);

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      padding-bottom: 70%;
      height: ${pxToRem(148)};
      width: ${pxToRem(148)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding-bottom: 100%;
      height: ${pxToRem(212)};
    `,
  )};
`;

export const image = css`
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  display: block;
  object-fit: cover;
  object-position: 50% 0;
  width: 100%;
  border-radius: ${pxToRem(10)};
`;

export const title = css`
  display: block;
  margin: ${stack(spacing.base)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  ${fontSize(text.HEADING.XS)}

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${fontSize(text.BODY.MD)}
    `,
  )}
`;

export const copyWrapper = css`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  padding: ${inset(spacing.md, 0)};

  .${copy.VISIT_SHOP_CLASSNAME} {
    display: none;

    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        display: block;
        width: ${pxToRem(183)};
        margin: ${pxToRem(spacing.xl)} auto ${pxToRem(spacing.xxl)};
      `,
    )}
  }
`;

export const location = css`
  margin: ${stack(spacing.base)};
  ${fontSize(text.BODY.SM)};
`;

const CONTACT_SELLER__ICON_WIDTH = 16;

export const contactSeller = css`
  --email-icon-color: var(--neutral-black-base);
  display: inline-flex;
  justify-self: center;
  margin: 0;
  padding: ${inset(spacing.xs, spacing.base)};
  padding-left: ${pxToRem(spacing.xs * 2 + CONTACT_SELLER__ICON_WIDTH)};
  color: var(--neutral-black-base);
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${fontSize(text.BODY.SM)};

  &:active {
    --email-icon-color: var(--brand-purple-base);
  }

  @media (hover: hover) {
    &:hover {
      --email-icon-color: var(--brand-purple-base);
    }
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: ${stack(spacing.xxl)};
    `,
  )}
`;

export const contactSellerIcon = css`
  position: absolute;
  left: -${spacing.xs + CONTACT_SELLER__ICON_WIDTH}px;
  top: 50%;
  transform: translateY(-50%);
`;
